/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.NoBoxCRM {

    @Serenity.Decorators.registerClass()
    export class FormSettingCategoryDialog extends NoboxEntityDialog<any, any> {
        protected getFormKey() { return FormSettingCategoryForm.formKey; }
        protected getIdProperty() { return FormRow.idProperty; }
        protected getLocalTextPrefix() { return FormRow.localTextPrefix; }
        protected getNameProperty() { return FormRow.nameProperty; }
        protected getService() { return FormService.baseUrl; }
        protected getDeletePermission() { return FormRow.deletePermission; }
        protected getInsertPermission() { return FormRow.insertPermission; }
        protected getUpdatePermission() { return FormRow.updatePermission; }

        protected form = new FormSettingCategoryForm(this.idPrefix);
        protected inpIdElm = `<input type="text" class="editor IdOption" value="DataValue" placeholder="Value" style="max-width: 40px;text-align:center;">`;
        protected inpNmElm = `<input type="text" class="editor NmOption ml-1" value="DataValue" placeholder="Text">`;
        protected btnDelete = `<a class="inplace-button deleteOption" title="Delete"><b><i class="fa fa-trash"></i></b></a>`;
        protected btnUp = `<a class="btn inplace-button upOption disabled" title="Move to top"><b><i class="fa fa-chevron-up"></i></b></a>`;
        protected btnDown = `<a class="btn inplace-button downOption disabled" title="Move to bottom"><b><i class="fa fa-chevron-down"></i></b></a>`;
        public data = [] as Array<selectOpsi>;
        public callback = (res: settingsForm) => {

        }

        constructor() {
            super();
        }

        loadEntity(entity: settingsForm) {
            super.loadEntity(entity);
            console.log(entity)
            if (entity.field == "category")
                this.form.Nm.value = entity.label;
        }

        onDialogOpen() {
            super.onDialogOpen();
            this.dialogTitle = "Category";
        }

        getToolbarButtons() {
            return [];
        }

        getDialogButtons() {
            var btn = [] as Serenity.DialogButton[];
            var $form = this.form;
            btn.push({
                text: "Ok",
                hint: "Ok",
                click: () => {
                    if (this.validateForm()) {
                        this.callback({
                            field: "category",
                            label: $form.Nm.value,
                            inputType: null,
                            placeHolder: null,
                            required: false,
                            selectOpsi: null,
                            orderQuantity: null
                        });
                        this.dialogClose();
                    }
                }
            });
            btn.push({
                text: "Cancel",
                hint: "Cancel",
                click: () => {
                    this.dialogClose();
                }
            })
            return btn;
        }
    }
}
